export default "__VITE_ASSET__CY3_r3c2__"